import { render } from "./Menu.vue?vue&type=template&id=dfd4ca42&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=dfd4ca42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dfd4ca42"

export default script